import React, { useEffect } from 'react';

import { accountApi } from '../api';

const Logout = (): React.ReactElement => {
  useEffect(() => {
    accountApi
      .logout({
        requireAuth: false,
      })
      .finally(() => {
        window.location.href = '/login?loggedOut=true';
      });
  }, []);

  return <div />;
};

export default Logout;
